export const convertMmToPx = (mm: number) => {
    return mm * 96 / 25.4;
}   

export const convertPxToMm = (px: number) => {
    return px * 25.4 / 96;
}export const convertMmToPx = (mm: number) => {
    return mm * 96 / 25.4;
}   

export const convertPxToMm = (px: number) => {
    return px * 25.4 / 96;
}